import { CourierFinancialDeliveryItem } from "./CourierFinancialDeliveryItem"
import { CourierPaymentRecord } from "./CourierPaymentRecord"

export class CourierFinancialSummary {
  companyId: number

  companyName: string

  courierId: string

  courierName: string

  courierEmail?: string

  courierPhone?: string

  deliveredCount: number

  deliveredAmount: number

  paidAmount: number

  confirmedAmount: number

  rejectedAmount: number

  pendingConfirmationAmount: number

  outstandingAmount: number

  deliveries: CourierFinancialDeliveryItem[]

  payments: CourierPaymentRecord[]

  constructor(data: Partial<CourierFinancialSummary> = {}) {
    this.companyId = data.companyId ?? -1

    this.companyName = data.companyName ?? ""

    this.courierId = data.courierId ?? ""

    this.courierName = data.courierName ?? ""

    this.courierEmail = data.courierEmail

    this.courierPhone = data.courierPhone

    this.deliveredCount = data.deliveredCount ?? 0

    this.deliveredAmount = Number(data.deliveredAmount ?? 0)

    this.paidAmount = Number(data.paidAmount ?? 0)

    this.confirmedAmount = Number(data.confirmedAmount ?? 0)

    this.rejectedAmount = Number(data.rejectedAmount ?? 0)

    this.pendingConfirmationAmount = Number(data.pendingConfirmationAmount ?? 0)

    this.outstandingAmount = Number(data.outstandingAmount ?? 0)

    this.deliveries = (data.deliveries ?? []).map((e) => new CourierFinancialDeliveryItem(e))

    this.payments = (data.payments ?? []).map((e) => new CourierPaymentRecord(e))
  }
}
